module.exports = __webpack_public_path__ + "static/media/bird_siting_page8.d240877e.png";